import { useI18n } from 'vue-i18n'

import useBlProviders from '../providers/useBlProvider'
import IncidentTagsDt from '@/services/dataTransferModules/incidentTagsDt'

export default function useIncidentTags(params = {}) {
	const incidentTagsDt = new IncidentTagsDt()

	const { t: $t } = useI18n()

	const defaults = {
		creatingIncidentTag: {
			name: '',
		},
		fieldsToPatch: ['name'],
	}

	const {
		loadEntityFlags: flags,

		entities: incidentTags,
		getEntities: getIncidentTags,

		createEntity: createIncidentTag,

		entity: incidentTag,
		getEntity: getIncidentTag,

		patchEntity: updateIncidentTag,
		updateEntity: fullUpdateIncidentTag,

		deleteEntity: deleteIncidentTag,
	} = useBlProviders(
		incidentTagsDt,
		Object.assign(
			{
				showErrorNotificationForLoadingAllEntities: true,
				errorNotificationTextForLoadingAllEntities: $t('Incident tag loading error'),

				showErrorNotificationForCreatingEntity: true,

				showErrorNotificationForLoadingOneEntity: true,

				showErrorNotificationForUpdatingEntity: true,
				errorNotificationTextForUpdatingEntity: $t('Error while editing incident tag'),

				showErrorNotificationForDeletingEntity: true,
			},
			params,
		),
	)

	return {
		flags,
		incidentTags,
		incidentTag,
		defaults,
		getIncidentTags,
		getIncidentTag,
		createIncidentTag,
		deleteIncidentTag,
		updateIncidentTag,
		fullUpdateIncidentTag,
	}
}
